import { render, staticRenderFns } from "./Vientiane.vue?vue&type=template&id=073f9270&"
import script from "./Vientiane.vue?vue&type=script&lang=js&"
export * from "./Vientiane.vue?vue&type=script&lang=js&"
import style0 from "./Vientiane.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports